import { create } from 'zustand'

export interface SessionStateProps {
  user: Model.Account
  status: Enum.UserStatus
  updateSession: (user: Model.Account, status?: Enum.UserStatus) => void
}

export const useSessionStore = create<SessionStateProps>((set) => {
  return {
    user: {
      name: '',
      email: '',
      phone_number: '',
      token: '',
      roles: [],
      permissions: [],
      firstAccess: false,
      avatar: '',
      corporate: {
        id: '',
        name: '',
        username: '',
        document: '',
        external_id: 0,
        data: {
          corporateId: 0,
          createdDate: 0,
          name: '',
          document: '',
          nameOnCard: '',
          email: '',
          planType: 'FREEMIUM',
          flexibleEnabled: false,
          swileCreditEnabled: false,
          validateEmailActivated: true,
          healthInsuranceSupport: false,
          corporateKycStatus: 'NEW',
          allowEmployeeToRequestExtraCards: false,
          emailsForExtraCards: false,
          issueFirstCardFee: true,
          issueSecondCardFee: true,
          multiFactorEnabled: true,
          useNetsuite: true,
          address: {
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            zipCode: '',
            city: '',
            state: '',
            country: ''
          },
          administrativeFee: 0,
          travelPlan: 'NONE',
          stats: []
        }
      }
    },
    status: 'loading',
    updateSession: (
      user: Omit<Model.Account, 'id'>,
      status?: Enum.UserStatus
    ) => {
      set((state) => ({
        user: {
          ...state.user,
          ...user,
          corporate: user.corporate
            ? {
                ...user.corporate,
                data: {
                  ...user.corporate.data,
                  corporateId:
                    user.corporate.data.corporateId ?? user.corporate.data.id,
                  createdDate:
                    user.corporate.data.createdDate ??
                    user.corporate.data.creationDate
                }
              }
            : state.user.corporate
        },
        status: status ?? state.status
      }))
    }
  }
})
